var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4173_56727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8359 18H5.83594C5.28365 18 4.83594 18.4477 4.83594 19C4.83594 19.5523 5.28365 20 5.83594 20H19.8359C20.3882 20 20.8359 19.5523 20.8359 19C20.8359 18.4477 20.3882 18 19.8359 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83594 17V19C4.83594 19.5523 5.28365 20 5.83594 20C6.38822 20 6.83594 19.5523 6.83594 19V17C6.83594 16.4477 6.38822 16 5.83594 16C5.28365 16 4.83594 16.4477 4.83594 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8359 17V19C18.8359 19.5523 19.2837 20 19.8359 20C20.3882 20 20.8359 19.5523 20.8359 19V17C20.8359 16.4477 20.3882 16 19.8359 16C19.2837 16 18.8359 16.4477 18.8359 17Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8359 15C12.6286 15.0016 12.4259 14.9387 12.2559 14.82L8.25589 12C8.0403 11.8471 7.89403 11.615 7.84906 11.3545C7.80408 11.0941 7.86407 10.8264 8.01589 10.61C8.09167 10.5019 8.18813 10.4098 8.29969 10.3391C8.41125 10.2684 8.53571 10.2206 8.66587 10.1982C8.79604 10.1759 8.92933 10.1796 9.05806 10.2091C9.18679 10.2386 9.30841 10.2933 9.41589 10.37L12.8359 12.76L16.2359 10.2C16.4481 10.0409 16.7148 9.97255 16.9773 10.0101C17.2399 10.0476 17.4768 10.1878 17.6359 10.4C17.795 10.6122 17.8633 10.8789 17.8258 11.1414C17.7883 11.404 17.6481 11.6409 17.4359 11.8L13.4359 14.8C13.2628 14.9298 13.0523 15 12.8359 15Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8359 13C12.5707 13 12.3164 12.8946 12.1288 12.7071C11.9413 12.5196 11.8359 12.2652 11.8359 12V4C11.8359 3.73478 11.9413 3.48043 12.1288 3.29289C12.3164 3.10536 12.5707 3 12.8359 3C13.1012 3 13.3555 3.10536 13.543 3.29289C13.7306 3.48043 13.8359 3.73478 13.8359 4V12C13.8359 12.2652 13.7306 12.5196 13.543 12.7071C13.3555 12.8946 13.1012 13 12.8359 13Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4173_56727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/iconDownload.8dfbf2320d509be09ab857f948c537d3.svg";
export { ForwardRef as ReactComponent };